import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

export interface IRegistrationItem {
  Name: string;
  Link: string;
  Status: string;
}

export interface IContinent {
  Name: string;
  Countries: IRegistrationItem[];
}

interface IGlobalRegistrationPageResult {
  fetch: {
    Common: {
      Page: {
        Title: string;
        Active: string;
        Subtitle: string;
        TitleColor: string | null;
        SubtitleColor: string | null;
        BackgroundColor: string | null;
        Open: string | null;
        ComingSoon: string | null;
        Closed: string | null;
        BackgroundImage: {
          src: string;
        } | null;
        Continents: IContinent[];
      } | null;
    };
  };
}

export type WithGlobalRegistrationPageQueryProps = QueryResult<
  IGlobalRegistrationPageResult
>;

class GlobalRegistrationPageQuery extends Query<
  IGlobalRegistrationPageResult
> {}

const withGlobalRegistrationPageQuery = <
  P extends WithGlobalRegistrationPageQueryProps
>(
  Component: React.ComponentType<P>
): React.SFC<Subtract<P, WithGlobalRegistrationPageQueryProps>> => props => {
  return (
    <GlobalRegistrationPageQuery
      query={queries.GET_GLOBAL_REGISTRATION_PAGE_DATA}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </GlobalRegistrationPageQuery>
  );
};

export default withGlobalRegistrationPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withGlobalRegistrationPageData.tsx